// Our probability for a player's market line, as PropCell shows it: the props row is found by
// player_id, then by name. null when there is no row, no line, or p is 0 (not expected to play).
export function propP(playerProps, side, item, market, line = "") {
  const rows = (playerProps && playerProps[side]) || [];
  const row =
    (item.player_id && rows.find((r) => r.player_id === item.player_id)) ||
    rows.find((r) => r.name === item.name);
  const price = row && row.markets && row.markets[market] && row.markets[market][line];
  const p = price && Number(price.p);
  return p > 0 ? p : null;
}

// leagues free accounts get our numbers for (matches the betslip service's FREE_LEAGUE_IDS)
export const FREE_LEAGUES = [8];

// Our numbers are locked for non-members outside the free leagues; sorting by them would
// give away the order, so the tables only sort by them when they're on show.
export function propsLocked(store, slipMatch) {
  if (store.getters.subscriptionType === "active") return false;
  return !FREE_LEAGUES.includes(slipMatch && slipMatch.league_id);
}
